export default __webpack_public_path__ + "static/media/186.30e34427.jpg";